<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <div style="font-size:28px;margin-bottom:20px;margin-left:20px">机构信息管理</div>

              <el-form
                :model="unitForm"
                :rules="rules"
                ref="unitRef"
                label-width="120px"
                class="demo-unitForm"
              >
                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="机构名称" prop="unit_name">
                      <el-input v-model="unitForm.unit_name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <!-- <el-form-item label="联系方式" prop="unit_contact">
                      <el-input v-model="unitForm.unit_contact"></el-input>
                    </el-form-item>-->
                    <el-form-item label="公益负责人" prop="public_master">
                      <el-input v-model="unitForm.public_master" placeholder="公益事务负责人"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="机构负责人" prop="unit_master">
                      <el-input v-model="unitForm.unit_master" placeholder="机构CEO姓名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="负责人手机号" prop="unit_master_contact">
                      <el-input v-model="unitForm.unit_master_contact" :maxlength="20"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="机构代码证号" prop="practice_license">
                      <el-input v-model.trim="unitForm.practice_license" :maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="医保资格" prop="quality">
                      <el-select v-model="unitForm.quality">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item label="体系" prop="system_type">
                      <el-select v-model="unitForm.system_type" placeholder="请选择体系">
                        <el-option
                          :label="item.text"
                          :value="item.value"
                          v-for="(item,index) in system_type_list"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-show="unitForm.quality==1">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="医保附件" prop="quality_pic_ids">
                      <el-upload
                        ref="picRef"
                        :action="uploadImgUrl"
                        list-type="picture-card"
                        :file-list="defImg"
                        :on-preview="handlePictureCardPreview"
                        :data="uploadParms"
                        name="img"
                        :before-upload="beforeUpload"
                        :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg');
                    }"
                        multiple
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="单位地址" prop="province_id" required>
                      <el-select
                        v-model="unitForm.province_id"
                        placeholder="请选择省份"
                        @change="getCity"
                        disabled
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in provinceLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="unitForm.city_id"
                        placeholder="请选择城市"
                        @change="getCounty"
                        :clearable="true"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in cityLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="unitForm.county_id"
                        placeholder="请选择县/区"
                        :clearable="true"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in countyLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="详细地址">
                      <el-input type="textarea" v-model="unitForm.unit_address" style="width:80%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>

              <div style="float:right;margin:20px;">
                <el-button
                  type="primary"
                  style="margin-top: 20px"
                  icon="el-icon-success"
                  @click="onSubmit"
                  :loading="loading"
                  size="medium"
                >保存</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import baseUrl from "@/config/index";
import myHead from "../public/head";
import centerHead from "../public/center_head";
import leftMenu from "../public/menu";
import footDiv from "../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };
    var checkRegion = (rule, value, callback) => {
      if (!this.unitForm.county_id && this.unitForm.if_china == 1) {
        return callback(new Error("请选择单位地址"));
      } else {
        return callback();
      }
    };
    return {
      loading: false,
      uploadImgUrl: "", //上传图片接口url
      dialogImageUrl: "", //图片预览路径
      countryLists: [], //国家列表
      dialogVisible: false, //图片预览弹窗
      uploadParms: { file_type: 2 }, //图片上传所需参数

      defImg: [],

      provinceLists: [], //省集合
      cityLists: [], //市集合
      countyLists: [], //县集合
      system_type_list: [],

      unitForm: {
        unit_name: null, //机构名称
        // unit_contact: null, //机构联系方式
        unit_master: null, //执行机构负责人
        unit_master_contact: null, //执行机构负责人联系方式
        system_type: null, //体系
        quality: null, //是否医保资格
        quality_pic_ids: [], //医保附件多图上传
        practice_license:'',
        province_id: null,
        city_id: null,
        county_id: null,
        unit_address: "", //详细地址
        quality_pic_ids_path: []
      },
      rules: {
        unit_name: [
          { required: true, message: "请输入单位名称", trigger: "blur" }
        ],
        // unit_contact: [
        //   { required: true, message: "请输入机构联系方式", trigger: "blur" }
        // ],
        unit_master: [
          { required: true, message: "请输入执行机构负责人", trigger: "blur" }
        ],
        unit_master_contact: [
          {
            required: true,
            message: "请输入执行机构负责人联系方式",
            trigger: "blur"
          },
          { validator: checkPhone, trigger: "blur" }
        ],
        practice_license: [
          { required: true, message: "请输入机构代码证号", trigger: "blur" }
        ],
        system_type: [
          {
            required: true,
            type: "number",
            message: "请输入执业许可证",
            trigger: "change"
          }
        ],

        public_master: [
          { required: true, message: "请输入公益事务负责人", trigger: "blur" }
        ],

        user_name: [
          { required: true, message: "请输入联系人名称", trigger: "blur" }
        ],
        duties: [
          { required: true, message: "请输入联系人职务", trigger: "blur" }
        ],
        email: [{ type: "email", message: "邮箱格式不正确", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        province_id: [{ validator: checkRegion, trigger: "change" }]
      }
    };
  },
  methods: {
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //表单提交
    onSubmit() {
      // this.$confirm(
      //   "修改单位信息，需要基金会再次审核才能进行系统操作，确认继续操作？",
      //   "操作提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }
      // )
      //   .then(() => {
          this.saveUnitInfo();
        // })
        // .catch(() => {
        //   return false;
        // });
    },
    saveUnitInfo() {
      this.$refs["unitRef"].validate(valid => {
        if (valid) {
          this.loading = true;
          let pic = this.defImg;
          if (pic.length > 0) {
            let arr = [];
            for (let item of pic) {
              if (item.hasOwnProperty("response")) {
                arr.push(item.response.data.id);
              } else {
                arr.push(item.id);
              }
            }
            this.unitForm.quality_pic_ids = arr;
          }
          this.$db
            .post(this.$db.config.submitUnitInfo, this.unitForm)
            .then(res => {
              this.loading = false;
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功！",
                  onClose: () => {
                    sessionStorage.removeItem("unitAuth");
                    this.$router.push("/unitLogin");
                    
                  },
                  duration: 1000
                });
              }
            });
        } else {
          this.$message.warning("请填写完整信息！");
          return false;
        }
      });
    },
    getCity(value, isEdit = false) {
      if (!isEdit) {
        this.unitForm.city_id = null;
        this.unitForm.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityLists = resp.data;
          }
        });
    },
    getCounty(value, isEdit = false) {
      if (!isEdit) {
        this.unitForm.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyLists = resp.data;
          }
        });
    },

    //获取体系字典
    getSystemType() {
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 200601,
          table: "pub_dict"
        })
        .then(res => {
          if (res.code == 200) {
            this.system_type_list = res.data;
          }
        });
    }
  },
  created() {
    
    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceLists = resp.data;
      }
    });

    this.$db.post(this.$db.config.getUnitInfoUrl, {}).then(res => {
      if (res.code == 200) {
        this.unitForm = res.data;
        this.unitForm.quality = Number(res.data.quality);
        this.defImg = res.data.quality_pic_ids_path;
        // this.defImg1 = [
        //   {
        //     id: res.data.practice_license_pic,
        //     url: res.data.practice_license_pic_url
        //   }
        // ];
        // this.defImg2 = [
        //   { id: res.data.unit_grade_pic, url: res.data.unit_grade_pic_url }
        // ];
        // 省市县
        if (res.data.province_id) {
          this.unitForm.province_id = res.data.province_id;
          this.getCity(this.unitForm.province_id, true);
        }

        if (res.data.city_id) {
          this.unitForm.city_id = res.data.city_id;
          this.getCounty(this.unitForm.city_id, true);
        }

        if (res.data.county_id) {
          this.unitForm.county_id = res.data.county_id;
        }
      }
    });
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;

    this.getSystemType();
    this.getCity(this.unitForm.province_id);
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/unit/info.vue